import type { TFunction } from "i18next";
import {
  toTranslatedOptions,
  type SharedSelectOption,
} from "./staffPanel.options.logic";

export type StaffVacationPayoutType = "Automatic" | "Manual";

/**
 * The statutory terms a new employment starts from. They stay editable, and an
 * employment that does not earn vacation days never sends them.
 */
export const DEFAULT_VACATION_TERMS = {
  vacationPayoutType: "Automatic",
  maxSickLeaveDays: "180",
  maxCareOfChildDays: "120",
  maxParentalLeaveDays: "120",
  advanceVacationDays: "0",
} as const;

export function toVacationPayoutOptions(
  translate: TFunction | ((key: string) => string),
): SharedSelectOption[] {
  const options: { value: StaffVacationPayoutType; label: string }[] = [
    { value: "Automatic", label: "Staff.AddStaffPanelVacationPayoutAutomatic" },
    { value: "Manual", label: "Staff.AddStaffPanelVacationPayoutManual" },
  ];
  return toTranslatedOptions(options, translate);
}
